import { FileUploadState } from "./types";

/**
 * Initial state for the File Storage module.
 * Defaults to Azure storage backend.
 */
const state: FileUploadState = {
  storageType: "azure",
};

export default state;
